var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _vm.isTotalCount
        ? _c("div", { staticClass: "grid_total" }, [
            _vm._v("\n        Total Count \n        "),
            _c("em", [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.totalCount)))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.gridId != null && _vm.gridId != ""
        ? _c("grid", {
            ref: _vm.gridId,
            attrs: {
              id: _vm.gridId,
              data: _vm.gridProps.data,
              columns: _vm.gridProps.columns,
              options: _vm.gridProps.options,
              pageOptions: _vm.gridProps.pageOptions,
              theme: _vm.gridProps.theme,
              language: _vm.gridProps.language,
              isTotalCount: _vm.isTotalCount
            },
            on: { click: _vm.onClick, check: _vm.onCheck, uncheck: _vm.onCheck }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24f01385", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f01385","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/knowledgeManager/trash/TrashListGrid.vue
// module id = uIVi
// module chunks = 0